export default {
  label: {
    message: {
      error: {
        addEmail: 'Add an email.',
        addAllEmails: 'All emails must be valid.',
      },
    },
  },
};
